import { css } from 'styled-components';

import { colors, transition } from 'theme/theme';

const listPadding = 48;

export const quillWrapperStyles = css`
  .ql-toolbar {
    border-radius: 8px;
    border: 1px solid ${colors.elementGrey};
    margin-bottom: 8px;
    padding: 4px;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .ql-fullscreen-holder {
    position: absolute;
    right: 10px;
    bottom: 0;
    opacity: 0.7;

    @media (hover: hover) {
      &:hover {
        opacity: 1;
      }
    }
  }

  .ql-formats {
    margin: 0;
    display: flex;
    gap: 2px;
  }

  .ql-formats > button {
    transition: ${transition};
    border-radius: 8px;
    width: 28px;
    height: 28px;
    padding: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:hover {
      box-shadow: inset 999px 999px rgb(0 0 0 / 10%);
    }

    &.ql-active {
      .ql-stroke {
        stroke: ${colors.brandBlue};
      }

      background: ${colors.softBlue};
    }

    &:not(.ql-active) {
      .ql-stroke {
        stroke: ${colors.mediumContentGrey};
      }

      &:hover {
        .ql-stroke {
          stroke: ${colors.mediumContentGrey};
        }
      }
    }
  }

  .ql-editor {
    overscroll-behavior: contain;
    padding: 12px;

    h4 strong {
      font-weight: inherit;
    }

    > :first-child {
      margin-top: 0;
    }

    > :last-child {
      margin-bottom: 0;
    }

    ol {
      padding-left: 0;
    }

    > ol > li[data-list='bullet'] {
      counter-set: list-0 0;
    }

    ol li {
      padding-left: ${listPadding}px;

      &[data-list='bullet'] {
        .ql-ui::before {
          content: none;
        }

        &::before {
          content: '•';
          margin-right: 6px;
        }
      }

      &[data-list='ordered'] {
        margin-left: 16px;
      }

      &.ql-indent-1 {
        padding-left: ${listPadding * 2}px;

        &[data-list='bullet'] {
          counter-set: list-1 0;

          &::before {
            content: '○';
          }
        }
      }

      &.ql-indent-2 {
        padding-left: ${listPadding * 3}px;

        &[data-list='bullet'] {
          counter-set: list-2 0;

          &::before {
            content: '▪';
          }
        }
      }

      &.ql-indent-3 {
        padding-left: ${listPadding * 4}px;

        &[data-list='bullet'] {
          counter-set: list-3 0;
        }
      }
    }
  }

  .ql-container {
    font-size: 16px;
    line-height: 1.75;
    color: ${colors.darkContentGrey};
    box-shadow: none;
    border: solid 1px ${colors.elementGrey};
    border-radius: 8px;
    transition: ${transition};

    a {
      color: ${colors.brandBlue};
    }

    &:focus-within {
      border-color: ${colors.brandBlue};

      /* NOTE: Using outlines instead of box shadow for 2 reasons:
        1. box shadows produces visual artifacts because
           they didn't blend properly with the border (seam).
           To fix that without making too many changes,
           I added an outline + negative offset.
        2. outlines work better with high-contrast OS appearance
        */
      outline: solid 2px ${colors.brandBlue};
      outline-offset: -1px;
      box-shadow: 0 0 0 1px ${colors.brandBlue};
    }

    &.ql-container--is-fullscreen {
      max-height: 100%;
      overflow-y: auto;
      width: 100%;
    }
  }

  .ql-tooltip {
    border-radius: 8px;
    z-index: 99;
  }

  .ql-action {
    color: ${colors.brandBlue};
  }
`;
